import React from 'react'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Box,
  Card,
  Chip,
  Divider,
  Hidden,
  TablePagination,
  Tooltip,
  Typography,
} from '@material-ui/core'

import useStyles from './styles'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import helpers from 'helpers'
import constants from 'constants/index'

const PhishingParticipantsTable = ({
  participants,
  isLoading,
  count,
  pagination = {},
  summary,
  hasCourse,
}) => {
  const classes = useStyles()
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    pagination

  const subtitleParts = [
    summary?.total != null && `${summary.total} participantes`,
    summary?.clicked != null && `${summary.clicked} cliques`,
    summary?.delivered != null && `${summary.compromised} enviaram dados`,
  ].filter(Boolean)

  return (
    <Card>
      <Box px={3} py={2}>
        <Typography variant="h5">
          Participantes — Resultados por etapa
        </Typography>
        {subtitleParts.length > 0 && (
          <Typography variant="body2" color="textSecondary">
            {subtitleParts.join(' · ')}
          </Typography>
        )}
      </Box>
      <Divider />
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table
          emptyMessage="Nenhum participante encontrado."
          isLoading={isLoading}
          size="small"
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell width="18%">Colaborador</TableCell>
              <TableCell width="18%">E-mail</TableCell>
              <TableCell width="14%">Departamento</TableCell>
              <TableCell align="center" width="7%">
                <Tooltip title="E-mail aberto pelo participante">
                  <span>Visualizado</span>
                </Tooltip>
              </TableCell>
              <TableCell align="center" width="7%">
                <Tooltip title="Participante clicou no link falso">
                  <span>Clique</span>
                </Tooltip>
              </TableCell>
              <TableCell align="center" width="7%">
                <Tooltip title="Participante interagiu com o conteúdo falso">
                  <span>Comprometido</span>
                </Tooltip>
              </TableCell>
              {hasCourse && (
                <TableCell align="center" width="7%">
                  <Tooltip title="Participante concluiu o curso de conscientização">
                    <Box component="span" whiteSpace="nowrap">
                      Fez o curso
                    </Box>
                  </Tooltip>
                </TableCell>
              )}
              <TableCell width="12%">Status</TableCell>
              <TableCell width="10%">Data</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {participants?.map((participant) => (
              <TableRow key={participant?.id}>
                <TableCell width="18%" applyNoWrap disableTooltip={false}>
                  {participant?.name ?? '-'}
                </TableCell>
                <TableCell width="18%" applyNoWrap disableTooltip={false}>
                  {participant?.email ?? '-'}
                </TableCell>
                <TableCell width="14%" applyNoWrap disableTooltip={false}>
                  {participant?.department ?? '-'}
                </TableCell>
                {[
                  participant?.viewed,
                  participant?.clicks,
                  participant?.compromised,
                  ...(hasCourse ? [participant?.courseCompleted] : []),
                ].map((value, index) => (
                  <TableCell key={index} align="center" width="7%">
                    <span
                      className={value ? classes.boolTrue : classes.boolFalse}
                    >
                      {value ? '✓' : '✗'}
                    </span>
                  </TableCell>
                ))}
                <TableCell width="12%">
                  {(() => {
                    const status = participant?.status
                    const label =
                      constants.phishing.PARTICIPANT_DISPLAY_STATUS_LABEL[
                        status
                      ]
                    const colorKey =
                      constants.phishing.PARTICIPANT_STATUS_COLOR[status]
                    if (!label) return '-'
                    return (
                      <Chip
                        label={label}
                        size="small"
                        className={`${classes.statusChip} ${
                          classes[
                            `status${colorKey
                              .charAt(0)
                              .toUpperCase()}${colorKey.slice(1)}`
                          ]
                        }`}
                      />
                    )
                  })()}
                </TableCell>
                <TableCell width="10%">
                  {participant?.date
                    ? helpers.formatters.ptBrFormatDateTime(participant?.date)
                    : '-'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
      <Box px={2}>
        <TablePagination
          component="div"
          count={count ?? 0}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={perPage}
          rowsPerPageOptions={[5, 10, 25, 100]}
          labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
          nextIconButtonProps={{ size: 'small' }}
          backIconButtonProps={{ size: 'small' }}
        />
      </Box>
    </Card>
  )
}

PhishingParticipantsTable.propTypes = {
  participants: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  count: PropTypes.number,
  pagination: PropTypes.object,
  summary: PropTypes.object,
  hasCourse: PropTypes.bool,
}

export default PhishingParticipantsTable
